module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/service_intro/replace/replace-banner.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a469e1f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/service_intro/replace/HomeReplaceBanner.vue
// module id = 168
// module chunks = 1